import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { ProtectedRoute, AppLayout } from './components';
import Login from './pages/Login';

// Admin Pages
import AdminDashboard from './pages/Admin/Dashboard';
import EmployeesPage from './pages/Admin/Employees';
import DatasetsPage from './pages/Admin/Datasets';
import AdminUploadPage from './pages/Admin/Upload';
import AdminMyUploadsPage from './pages/Admin/MyUploads';

// Employee Pages
import EmployeeDashboard from './pages/Employee/Dashboard';
import UploadPage from './pages/Employee/Upload';
import MyUploadsPage from './pages/Employee/MyUploads';

import './App.css';

const App: React.FC = () => {
  return (
    <ConfigProvider locale={zhCN}>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          {/* Admin Routes */}
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute requireAdmin>
                <AppLayout>
                  <AdminDashboard />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/employees"
            element={
              <ProtectedRoute requireAdmin>
                <AppLayout>
                  <EmployeesPage />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/datasets"
            element={
              <ProtectedRoute requireAdmin>
                <AppLayout>
                  <DatasetsPage />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/upload"
            element={
              <ProtectedRoute requireAdmin>
                <AppLayout>
                  <AdminUploadPage />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/my-uploads"
            element={
              <ProtectedRoute requireAdmin>
                <AppLayout>
                  <AdminMyUploadsPage />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          {/* Employee Routes */}
          <Route
            path="/employee/dashboard"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <EmployeeDashboard />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee/upload"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <UploadPage />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee/my-uploads"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <MyUploadsPage />
                </AppLayout>
              </ProtectedRoute>
            }
          />

          {/* Default Redirect */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </ConfigProvider>
  );
};

export default App;
